export const PageUrls = Object.freeze({
  LOGIN: "/login.php",
});
